export const style = {
  tabPanel: {
    sx: {
      p: '0px 24px',
    },
  },
} as const;
